import { Checkbox, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLeaveHistory extends Layout {
    checkboxIsProcessed: Checkbox;
    checkboxIsVoid: Checkbox;
    labelBatch: Label;
    panelBatch: Panel;
    panelContain: Panel;
    sourceLeaveTransaction: DataSource;
    switchType: Switch;
    textboxAmount: Textbox;
    textboxAppliesTo: Textbox;
    textboxBatchCode: Textbox;
    textboxBatchNumber: Textbox;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxEffect: Textbox;
    textboxId: Textbox;
    textboxMemo: Textbox;
    textboxPayeeId: Textbox;
    textboxTrxDate: Textbox;
}
